namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumConnectPrinterFg {
        ConnectPrinterFgNo = 0,
        ConnectPrinterFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumConnectPrinterFg, 'GeniuzPOS.InitialData.PsPosStationEumConnectPrinterFg');
}
